// import Gallery_1 from './Gallery_1.vue'

export default {
  // Gallery_1: Gallery_1
}
